import React from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {Select, DatePicker} from 'antd';
import {ExTable} from 'icsoc-antd-ex';
import UnionSearch from 'Components/union/unionSearch';
import actions from 'Actions/taskManage/questionNaire';
import tDetailActions from 'Actions/taskManage/detail';
import moment from 'moment';

const {
  Filter,
  Filter: {NormalFilter},
} = ExTable;
const {Option} = Select;
const {RangePicker} = DatePicker;

class Search extends UnionSearch {
  componentDidMount() {
    const {tDetActions} = this.props;

    // 获取任务名称下拉框
    tDetActions.getTaskNameOptions();
  }

  // 点击查询
  handleFilter = fields => {
    const {topSearch, actions} = this.props;
    const {taskId, taskCommitDate} = fields;
    actions.setHeadSearchData({});
    const startMillis =
      taskCommitDate && taskCommitDate.length
        ? taskCommitDate[0].format('x')
        : undefined;
    const endMillis =
      taskCommitDate && taskCommitDate.length
        ? taskCommitDate[1].format('x')
        : undefined;
    const params = {
      startMillis,
      endMillis,
      taskId,
      questionQueryReqs: {},
    };
    if (taskId) {
      this.onOk(params, 'noTable');
      topSearch(params);
      // actions.getQuestionNaireConnect(params);
      // actions.getQuestionNaireAnswer(params);
    }
  };

  render() {
    const {taskNameOptions} = this.props;
    return (
      <div className="search">
        <Filter handleFilter={this.handleFilter}>
          <NormalFilter>
            <NormalFilter.Item label="时间范围：" field="taskCommitDate" 
              initialValue={[moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')]}>
              <RangePicker
                placeholder={['开始日期', '结束日期']}
                showTime={{
                  hideDisabledOptions: true,
                  defaultValue: [
                    moment('00:00:00', 'HH:mm:ss'),
                    moment('23:59:59', 'HH:mm:ss'),
                  ],
                }}
                format="YYYY-MM-DD HH:mm:ss"
              />
            </NormalFilter.Item>
            <NormalFilter.Item label="任务名称" field="taskId">
              <Select
                showSearch
                allowClear
                placeholder="请选择任务"
                optionFilterProp="children"
                filterOption={(input, option) =>
                  option.props.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }>
                {Array.isArray(taskNameOptions)
                  ? taskNameOptions.map(({taskId, taskName}) => (
                      <Option value={taskId} key={taskId}>
                        {taskName}
                      </Option>
                    ))
                  : null}
              </Select>
            </NormalFilter.Item>
          </NormalFilter>
        </Filter>
      </div>
    );
  }
}

const mapStateToProps = ({taskManageQuestionNaire, taskManageDetail}) => ({
  searchData: taskManageQuestionNaire.searchData,
  pageStatus: taskManageQuestionNaire.pageStatus,
  // questionQueryReqs: taskManageQuestionNaire.questionQueryReqs,
  taskNameOptions: taskManageDetail.taskNameOptions,
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actions, dispatch),
  tDetActions: bindActionCreators(tDetailActions, dispatch),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Search);
